import { InvoiceGovernmentOperationLabel } from '@/core/domain/invoice/invoice/invoice.enums';
import { Select, SelectProps } from 'antd';

export default function SelectGovernmentOperation(props: SelectProps) {
  const options = Object.keys(InvoiceGovernmentOperationLabel).map((key) => ({
    value: key,
    label:
      InvoiceGovernmentOperationLabel[
        key as keyof typeof InvoiceGovernmentOperationLabel
      ],
  }));

  return (
    <Select
      {...props}
      options={options}
      style={{ ...props.style, width: '100%' }}
    />
  );
}
